import { render, staticRenderFns } from "./free-upgrade-modal.vue?vue&type=template&id=0e7fff9c&scoped=true&"
import script from "./free-upgrade-modal.vue?vue&type=script&lang=js&"
export * from "./free-upgrade-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7fff9c",
  null
  
)

export default component.exports